import React, { useState, useEffect, useContext} from 'react';
//import Calendar from './calendar';
import '../../../../css/calendar.css';
import ScheduleCall from './scheduleCall';
import AttachFile from './attachFile';
import Calendar2 from './calendar2';
import { useSelector } from 'react-redux';
import BrandedButton, { brandedButtonTypes } from '../../../../utilities/inputComponents/BrandedButton';
import { AgentContext } from '../../../../context/AgentContext';

function LeadTopBarButton({newEvent, title, handleSetScripting, setApptSet, qualifier, newEventPackage, defaultCalendar, setEvent, newAppt, setNewAppt, update, buttonCount}) {
    const [isOpen, setIsOpen] = useState(false);
    const triggerCalender=useSelector((state) => state.appointment.triggerCalendar);
    const [selected, setSelected] = useState(false);
    const [calendar, setCalendar] = useState(false);
    const [calIsOpen, setCalIsOpen] = useState(false);
    const leadsAlldata = useSelector((state) => state.leadAllDataInfo?.leadsAllInfoData);
    const {isB2B} = useContext(AgentContext)


    const getMarginTop = () => {
        return buttonCount <= 4 ? '60px' : '370px';
    };

    const handleClick = (link) => {
        window.open(link, '_blank');
    };

    const handleOpen=(title)=>{
        setCalIsOpen(!calIsOpen);
        if(title===selected){
            setSelected(false);
        }
        else{
            setSelected(title)
        }
    }
    useEffect(() => {
        if(triggerCalender){
            setCalIsOpen(true)
        }
    }, [triggerCalender]);

    return (
        <>
            {title === "Lead PDF" ? (
                <div style={{ minWidth: '20%', height: 35 }}>
                    <BrandedButton
                        buttonLabel={title}
                        buttonType={brandedButtonTypes.SECONDARY}
                        clickHandler={_ => handleClick(leadsAlldata.pdf)}
                    />
                </div>
            ) : title === 'Appointment' ? (
                <>
                    <div style={{ minWidth: leadsAlldata.pdf === null ? '25%' : '20%', height: 35 }}>
                        <BrandedButton
                            buttonLabel={title}
                            buttonType={brandedButtonTypes.SECONDARY}
                            clickHandler={_ => handleOpen(title)}
                        />
                    </div>
                    <div className={`calendarWrapper ${calIsOpen ? 'openCal' : ''}`}>
                        {calIsOpen && (
                            <Calendar2 newEvent={newEvent} setApptSet={setApptSet} update={update} newAppt={newAppt} setNewAppt={setNewAppt} setIsOpen={setCalIsOpen} defaultCalendar={defaultCalendar} newEventPackage={newEventPackage} setEvent={setEvent} />
                        )}
                    </div>
                </>
            ) : title === 'Qualifier' ? (
                <div style={{ minWidth: leadsAlldata.pdf === null ? '25%' : '20%', height: 35 }}>
                    <BrandedButton
                        buttonLabel={title}
                        buttonType={brandedButtonTypes.SECONDARY}
                        clickHandler={_ => handleSetScripting(true)}
                    />
                </div>
            ) : title === "Schedule Call" ? (
                <>
                    <div style={{ minWidth: leadsAlldata.pdf === null ? '25%' : '20%', height: 35 }}>
                        <BrandedButton
                            buttonLabel={title}
                            buttonType={brandedButtonTypes.SECONDARY}
                            clickHandler={_ => setIsOpen(!isOpen)}
                        />
                    </div>
                    <div
                        className={`dialogBox ${isOpen ? 'openBox' : ''}`}
                        style={{
                            marginTop: isOpen ? isB2B ? getMarginTop() : '60px' : undefined,
                            transition: isB2B ? 'all 0.5s ease-in-out' : undefined
                        }}
                    >
                        <ScheduleCall />
                    </div>
                </>
            ) : title === "Attach File" ? (
                <>
                    <div style={{ minWidth: leadsAlldata.pdf === null ? '25%' : '20%', height: 35 }}>
                        <BrandedButton
                            buttonLabel={title}
                            buttonType={brandedButtonTypes.SECONDARY}
                            clickHandler={_ => setIsOpen(!isOpen)}
                        />
                    </div>
                    <div
                        className={`dialogBox ${isOpen ? 'openBox' : ''}`}
                        style={{
                            overflow: 'auto',
                            marginTop: isOpen ? isB2B ? getMarginTop() : '60px' : undefined ,
                            transition: isB2B ? 'all 0.5s ease-in-out' : undefined
                        }}
                    >
                        <AttachFile files={leadsAlldata.file_link} leadId={leadsAlldata.lead_id} />
                    </div>
                </>
            ) : (
                <>
                    <div style={{ minWidth: leadsAlldata.pdf === null ? '25%' : '20%', height: 35 }}>
                        <BrandedButton
                            buttonLabel={title}
                            buttonType={brandedButtonTypes.SECONDARY}
                            clickHandler={_ => handleOpen(title)}
                        />
                    </div>
                    <div className={`dialogBox ${isOpen ? 'openBox' : ''}`}>
                    </div>
                </>
            )}
        </>
    );

}

export default LeadTopBarButton;
